import QUERY_KEYS from 'services/api/queryKeys';
import {
  BookingRemindType,
  PaginationType,
  ParamsGetBookingReminds
} from 'services/api/type/booking.type';
import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import get from 'lodash/get';
import { PAGE_SIZE_BOOKING_REMINDS } from 'services/api/module/booking.api';

export const useGetBookingReminds = (
  params: ParamsGetBookingReminds,
  pageSize: number = PAGE_SIZE_BOOKING_REMINDS,
  page: number = 1
) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_BOOKING_REMINDS, params, page],
    queryFn: () => API.booking.getBookingReminds(params, pageSize, page)
  });

  return {
    data: get(data, 'data', []) as BookingRemindType[],
    pagination: get(data, 'pagination', {}) as PaginationType,
    isLoading
  };
};
